import React, { useState, useEffect } from "react";
import ShowClimateFootprintInKg from "./ShowClimateFootprintInKg";
import ShowOtherFootprint from "./ShowOtherfootprint";
import AllergiesAndRiskCardPdf from "./AllergiesAndRiskCard";
import { useTranslation } from '../../hooks/useTranslation';

const ReportAdditionalInfo = ({ dishData, certificates, dish}) => {
  const {
    riskIngredients = [],
    allergies = [],
    overconsumptions = [],
  } = dishData || {};

  const [carbon, setCarbon] = useState(0);
  const [waterFootprint, setWaterFootprint] = useState(0);
  const { t } = useTranslation();

  useEffect(() => {
    setCarbon(dish?.CO2e_menuwise);

    if (dish?.water_in_m3ton) {
      setWaterFootprint(dish?.water_in_m3ton?.total);
    }
  }, [dish?.CO2e_menuwise, dish?.water_in_m3ton]);

  return (
    <div className="p-2 mx-auto flex gap-2 w-full h-[210px]">
      <div className="flex flex-col justify-start gap-[0.2rem] w-1/3 h-full">
        <ShowClimateFootprintInKg co2ePerKg={carbon} size={dish?.size} unit_id={dish?.unit_id} t={t} />
        <ShowOtherFootprint title={t("Vattenavtryck (H₂O)")} value={`${waterFootprint? `${Math.round(waterFootprint)} ${t("liter")}` : ''}`}/>
        {/* <ShowOtherFootprint title={t("Transportsträcka")} value={transport_distance?.value ? `${transport_distance.value} km` : ''} /> */}
      </div>
      <div className="bg-transparent px-0 rounded-2xl grid grid-cols-3 gap-1 w-full h-full overflow-hidden print:bg-white">
        <AllergiesAndRiskCardPdf
          header={t("ALLERGENER & INTOLERANSER")}
          values={allergies}
          t={t}
        />
        <AllergiesAndRiskCardPdf
          header={t("RISKINGREDIENS")}
          value={riskIngredients}
          t={t}
        />
        <AllergiesAndRiskCardPdf
          header={t("RISK FÖR ÖVERKONSUMTION")}
          value={overconsumptions}
          t={t}
        />
        {/* <CertificatesCardPdf
          header={t("CERTIFIERINGAR")}
          certificatesImages={certificatesImages}
          t={t}
        /> */}
      </div>
    </div>
  );
};

export default ReportAdditionalInfo;
